import { useEffect } from 'react';
import { Input, Form, Typography } from 'antd';
import Discord from "../assets/discord.svg";
import Telegram from "../assets/telegram.svg";

const SocialUsernameForm = ({ 
  step, 
  form, 
  currentDiscord, 
  currentTelegram 
}) => {

  useEffect(() => {
    form.setFieldsValue({
      discordUsername: currentDiscord || '',
      telegramUsername: currentTelegram || ''
    });
  }, [form, currentDiscord, currentTelegram]);

  return (
    <div className="mt-6">
      <Typography.Title level={5} className="text-left">
      Username
      </Typography.Title>
      
      <Form form={form} layout="vertical">
        <div className="grid">
          {step === "discord" && (
            <Form.Item
              // label="Discord"
              name="discordUsername"
              initialValue={currentDiscord}
              // rules={[
              //   { 
              //     pattern: /^.{3,32}#[0-9]{4}$/,
              //     message: 'Format: username#1234'
              //   }
              // ]}
            >
              <Input
                placeholder="Discord username"
                prefix={<img src={Discord} alt="Discord" className="h-3" />}
              />
            </Form.Item>
          )}

          {step === "telegram" && (
            <Form.Item
              // label="Telegram"
              name="telegramUsername"
              initialValue={currentTelegram}
              // rules={[
              //   { 
              //     pattern: /^@?(\w){5,32}$/,
              //     message: '5-32 characters, @ optional'
              //   }
              // ]}
            >
              <Input
                placeholder="Telegram username"
                prefix={<img src={Telegram} alt="Telegram" className="h-3" />}
              />
            </Form.Item>
          )}
        </div>
      </Form>
    </div>
  );
};

export default SocialUsernameForm;